<div class="widget">

  <div class="walletBox" [ngClass]="{'connected': !!walletAddress}">

    <div class="w-100 d-flex flex-column align-items-center justify-content-start text-center">

      <p class="widget-title text-capitalize fw-bold" *ngIf="isClaimLive">{{"widget.claim_live" | translate }}
      </p>
      <p class="font-14 font-sm-15 text-white fw-regular" *ngIf="isClaimLive">{{"widget.claim_desc" | translate }}</p>




      <!-- ======= STAKEABLE  balance ======= -->

      <div class="d-flex justify-content-center align-items-center text-center information-txt mar-b px-3 mb-2"
        [ngClass]="[(!userEthClaimable && userEthClaimable < 0) ? 'shimmer' :'']" *ngIf="walletAddress">
        <span class="text-uppercase me-1">{{"widget.your_claimable" | translate :{tokenName} }}</span>
        <span class="fw-semibold lh-1"> = {{convertNum(userEthClaimable)}}</span>

      </div>

      <div class="swapArea">
        <div class="d-flex align-items-center justify-content-center gap-3 mt-4 mb-2" *ngIf="!walletAddress">
          <button class="btn btn-primary w-100 p-3" (click)="connectModal()" *ngIf="!showBW && !walletAddress"><span
              translate>misc.connect_wallet</span></button>
          
          <button class="btn btn-primary w-100" (click)="connectBestWallet()" *ngIf="showBW"><span
              translate>misc.connect_bw_wallet</span></button>
        </div>

        <div class="d-flex flex-column align-items-center justify-content-center gap-2 mt-3 "
          *ngIf="walletAddress && isClaimLive">
          <button [ngClass]="{'disabled-btn':userEthClaimable == 0}" class="btn btn-primary px-0 w-100 p-3 mt-2"
            (click)="claim()">
            <span class="font-16 font-sm-20" translate>widget.claim_token</span>
          </button>
          <button class="btn btn-primary w-100 p-3 mt-2" (click)="disconnect()"><span
              translate>{{walletAddress | trimAddress}}</span></button>
        </div>

      </div>
    </div>
  </div>